<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <circle opacity="0.1" cx="32.5" cy="32.5" r="32.5" fill="#F57A4D" />
    <path
      d="M45 46.0003H43.1429V41.3574C43.1414 40.1265 42.6518 38.9464 41.7814 38.0761C40.911 37.2057 39.7309 36.716 38.5 36.7146V34.8574C40.2233 34.8594 41.8755 35.5448 43.094 36.7634C44.3126 37.982 44.998 39.6341 45 41.3574V46.0003Z"
      fill="#F57A4D"
    />
    <path
      d="M37.5714 46.0003H35.7143V41.3574C35.7128 40.1265 35.2232 38.9464 34.3528 38.0761C33.4824 37.2057 32.3023 36.716 31.0714 36.7146H25.5C24.2691 36.716 23.089 37.2057 22.2186 38.0761C21.3482 38.9464 20.8586 40.1265 20.8571 41.3574V46.0003H19V41.3574C19.002 39.6341 19.6874 37.982 20.906 36.7634C22.1245 35.5448 23.7767 34.8594 25.5 34.8574H31.0714C32.7947 34.8594 34.4469 35.5448 35.6655 36.7634C36.884 37.982 37.5695 39.6341 37.5714 41.3574V46.0003Z"
      fill="#F57A4D"
    />
    <path
      d="M35.7148 20V21.8571C36.9462 21.8571 38.1271 22.3463 38.9978 23.217C39.8685 24.0877 40.3577 25.2686 40.3577 26.5C40.3577 27.7314 39.8685 28.9123 38.9978 29.783C38.1271 30.6537 36.9462 31.1429 35.7148 31.1429V33C37.4388 33 39.0921 32.3152 40.311 31.0962C41.53 29.8772 42.2148 28.2239 42.2148 26.5C42.2148 24.7761 41.53 23.1228 40.311 21.9038C39.0921 20.6848 37.4388 20 35.7148 20Z"
      fill="#F57A4D"
    />
    <path
      d="M28.2852 21.8571C29.2034 21.8571 30.1011 22.1294 30.8646 22.6396C31.6281 23.1498 32.2232 23.8749 32.5746 24.7233C32.926 25.5716 33.018 26.5052 32.8388 27.4058C32.6597 28.3064 32.2175 29.1337 31.5682 29.783C30.9188 30.4323 30.0916 30.8745 29.1909 31.0536C28.2903 31.2328 27.3568 31.1408 26.5084 30.7894C25.66 30.438 24.9349 29.8429 24.4248 29.0794C23.9146 28.3159 23.6423 27.4183 23.6423 26.5C23.6423 25.2686 24.1315 24.0877 25.0022 23.217C25.8729 22.3463 27.0538 21.8571 28.2852 21.8571ZM28.2852 20C26.9996 20 25.7429 20.3812 24.674 21.0954C23.605 21.8097 22.7719 22.8248 22.2799 24.0126C21.788 25.2003 21.6593 26.5072 21.9101 27.7681C22.1609 29.029 22.7799 30.1872 23.689 31.0962C24.598 32.0052 25.7562 32.6243 27.0171 32.8751C28.2779 33.1259 29.5849 32.9972 30.7726 32.5052C31.9603 32.0132 32.9755 31.1801 33.6897 30.1112C34.4039 29.0423 34.7852 27.7856 34.7852 26.5C34.7852 24.7761 34.1003 23.1228 32.8814 21.9038C31.6624 20.6848 30.0091 20 28.2852 20Z"
      fill="#F57A4D"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
